if (!customElements.get('compact-product-bundle')) {
  customElements.define(
    'compact-product-bundle',

    class CompactProductBundle extends BaseElement {
      connectedCallback() {
        super.connectedCallback();
        this.on(this, 'click', (event) => {
          const btn = event.target.closest('[data-product-bundle-submit]');
          if (btn) this.onSubmitHandler(event, btn);
        });
      }

      get variants() {
        return Array.from(this.querySelectorAll('form[is="product-bundle-form"] [name="id"]'));
      }

      get submitButton() {
        return this.querySelector('[data-product-bundle-submit]');
      }

      get cartDrawer() {
        return document.querySelector('cart-drawer');
      }

      onSubmitHandler(event, clickedButton = this.submitButton) {
        const data = {
          items: this.variants.map(variant => ({
            id: variant.value,
            quantity: variant.getAttribute('data-min')
          }))
        };

        if (document.body.classList.contains('template-cart') || theme.settings.cartType === 'page') {
          theme.utils.postLink2(theme.routes.cart_add_url, {
            parameters: {
              ...data
            }
          });
          return;
        }

        event.preventDefault();
        if (clickedButton.hasAttribute('aria-busy')) return;
        this.error = false;
        this.activeElement = event.target.closest('[data-product-bundle-submit]') || event.currentTarget;

        this.handleErrorMessage();

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

        const body = JSON.stringify({
          ...data,
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        });

        clickedButton.setAttribute('aria-disabled', 'true');
        clickedButton.setAttribute('aria-busy', 'true');

        fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig('javascript'), body })

          .then((response) => response.json())
          .then(async (parsedState) => {
            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                detail: {
                  errorMessage: parsedState.description
                }
              }));

              const submitButtonText = clickedButton.querySelector('.btn-text span');
              if (!submitButtonText || !submitButtonText.hasAttribute('data-sold-out')) return;
              submitButtonText.innerText = submitButtonText.getAttribute('data-sold-out');
              clickedButton.setAttribute('aria-disabled', 'true');
              this.error = true;
              return;
            }

            const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
            cartJson['sections'] = parsedState['sections'];

            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'compact-product-bundle', cart: cartJson });
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: parsedState
              }
            }));

          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            clickedButton.removeAttribute('aria-busy');

            if (!this.error) {
              clickedButton.removeAttribute('aria-disabled');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessage = this.errorMessage || this.querySelector('.product-form__error-message');
        if (!this.errorMessage) return;

        this.errorMessage.toggleAttribute('hidden', !errorMessage);
        this.errorMessage.innerText = errorMessage;
      }
    }
  );
}
